import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__collections } from '../STATE__collections';

export const LOCAL__collection_set_current = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.COLLECTIONS_SET_CURRENT,
  payload,
});

export const INIT_LOCAL__collection_set_current = (state: STATE__collections, action: PayloadAction<string>) => {
  if (action.payload == state.collection_current._id) return;

  let collection_id = action.payload;

  let collection = collection_id ? state.collections_map.get_or_assert(collection_id, { context: 'collection' }) : DTO__collection.CREATE_STUB();

  state.collection_current = collection;
};
